import { MethodWithParameters } from 'eurogard-pattern';
import { ControlOptions } from '@rxap/utilities';
import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  UserControllerGetByUuidRemoteMethod
} from 'open-api-legacy/remote-methods/user-controller-get-by-uuid.remote-method';
import {
  UserSettingsAccordionDataSource
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-settings-accordion.data-source';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  NotificationAccordionSubscribedRoutersControllerGetAutocompleteRouterOptionListRemoteMethod
} from 'open-api-service-shared-features/remote-methods/notification-accordion-subscribed-routers-controller-get-autocomplete-router-option-list.remote-method';

@Injectable()
export class SubscribedRoutersAutocompleteMethod implements MethodWithParameters<ControlOptions, {
  parameters: { search: string }
}> {
  private companyUuid: string | undefined = undefined;

  private readonly getUser = inject(UserControllerGetByUuidRemoteMethod);
  public readonly accordionDataSource = inject(UserSettingsAccordionDataSource);
  public readonly data = toSignal(this.accordionDataSource.connect({id: 'to-signal-user-settings-accordion'}));

  private readonly getOptionList = inject(
    NotificationAccordionSubscribedRoutersControllerGetAutocompleteRouterOptionListRemoteMethod
  );

  private readonly route = inject(ActivatedRoute);

  async call(parameters: { parameters: { search: string } }): Promise<ControlOptions> {
    const userUuid = this.data()!.uuid;
    if (this.companyUuid === undefined) {
      this.companyUuid = (await this.getUser.call({ parameters: { uuid: userUuid } })).companyUuid;
    }
    return this.getOptionList.call({
      parameters: {
        uuid: userUuid,
        search: parameters.parameters.search,
        company: this.companyUuid!
      },
    });
  }

}
